const $a5fd07fa01589658$var$GRID_SIZE = 4;
const $a5fd07fa01589658$var$CELL_SIZE = 12;
const $a5fd07fa01589658$var$CELL_GAP = 2;
class $a5fd07fa01589658$export$2e2bcd8739ae039 {
    #cells;
    constructor(gridElement){
        gridElement.style.setProperty("--grid-size", $a5fd07fa01589658$var$GRID_SIZE);
        gridElement.style.setProperty("--cell-size", `${$a5fd07fa01589658$var$CELL_SIZE}vmin`);
        gridElement.style.setProperty("--cell-gap", `${$a5fd07fa01589658$var$CELL_GAP}vmin`);
        this.#cells = $a5fd07fa01589658$var$createCellElements(gridElement).map((cellElement, index)=>{
            return new $a5fd07fa01589658$var$Cell(cellElement, index % $a5fd07fa01589658$var$GRID_SIZE, Math.floor(index / $a5fd07fa01589658$var$GRID_SIZE));
        });
    }
    get cells() {
        return this.#cells;
    }
    get cellsByColumn() {
        return this.#cells.reduce((cellGrid, cell)=>{
            cellGrid[cell.x] = cellGrid[cell.x] || [];
            cellGrid[cell.x][cell.y] = cell;
            return cellGrid;
        }, []);
    }
    get cellsByRow() {
        return this.#cells.reduce((cellGrid, cell)=>{
            cellGrid[cell.y] = cellGrid[cell.y] || [];
            cellGrid[cell.y][cell.x] = cell;
            return cellGrid;
        }, []);
    }
    get #emptyCells() {
        return this.#cells.filter((cell)=>cell.tile == null);
    }
    randomEmptyCell() {
        const randomIndex = Math.floor(Math.random() * this.#emptyCells.length);
        return this.#emptyCells[randomIndex];
    }
}
class $a5fd07fa01589658$var$Cell {
    #cellElement;
    #x;
    #y;
    #tile;
    #mergeTile;
    constructor(cellElement, x, y){
        this.#cellElement = cellElement;
        this.#x = x;
        this.#y = y;
    }
    get x() {
        return this.#x;
    }
    get y() {
        return this.#y;
    }
    get tile() {
        return this.#tile;
    }
    set tile(value) {
        this.#tile = value;
        if (value == null) return;
        this.#tile.x = this.#x;
        this.#tile.y = this.#y;
    }
    get mergeTile() {
        return this.#mergeTile;
    }
    set mergeTile(value) {
        this.#mergeTile = value;
        if (value == null) return;
        this.#mergeTile.x = this.#x;
        this.#mergeTile.y = this.#y;
    }
    canAccept(tile) {
        return this.tile == null || this.mergeTile == null && this.tile.value === tile.value;
    }
    mergeTiles() {
        if (this.tile == null || this.mergeTile == null) return;
        this.tile.value = this.tile.value + this.mergeTile.value;
        this.mergeTile.remove();
        this.mergeTile = null;
    }
}
function $a5fd07fa01589658$var$createCellElements(gridElement) {
    const cells = [];
    for(let i = 0; i < $a5fd07fa01589658$var$GRID_SIZE * $a5fd07fa01589658$var$GRID_SIZE; i++){
        const cell = document.createElement("div");
        cell.classList.add("cell");
        cells.push(cell);
        gridElement.append(cell);
    }
    return cells;
}


class $296a42d4036cf796$export$2e2bcd8739ae039 {
    #tileElement;
    #x;
    #y;
    #value;
    constructor(tileContainer, value = Math.random() > 0.5 ? 2 : 4){
        this.#tileElement = document.createElement("div");
        this.#tileElement.classList.add("tile");
        tileContainer.append(this.#tileElement);
        this.value = value;
    }
    get value() {
        return this.#value;
    }
    set value(v) {
        this.#value = v;
        this.#tileElement.textContent = v;
        const power = Math.log2(v);
        const backgroundLightness = 100 - power * 9;
        this.#tileElement.style.setProperty("--background-lightness", `${backgroundLightness}%`);
        this.#tileElement.style.setProperty("--text-lightness", `${backgroundLightness <= 50 ? 90 : 10}%`);
    }
    set x(value) {
        this.#x = value;
        this.#tileElement.style.setProperty("--x", value);
    }
    set y(value) {
        this.#y = value;
        this.#tileElement.style.setProperty("--y", value);
    }
    remove() {
        this.#tileElement.remove();
    }
    waitForTransition(animation = false) {
        return new Promise((resolve)=>{
            this.#tileElement.addEventListener(animation ? "animationend" : "transitionend", resolve, {
                once: true
            });
        });
    }
}


const $09e991522ca7e64e$var$gameBoard = document.getElementById("game-board");
const $09e991522ca7e64e$var$button = document.querySelector(".button");
const $09e991522ca7e64e$var$scoreField = document.querySelector(".game-score");
const $09e991522ca7e64e$var$bestField = document.querySelector(".game-best");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message-start");
const $09e991522ca7e64e$var$winMessage = document.querySelector(".message-win");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$endMessage = document.querySelector(".message-end");
let $09e991522ca7e64e$var$grid = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)($09e991522ca7e64e$var$gameBoard);
let $09e991522ca7e64e$var$score = 0;
let $09e991522ca7e64e$var$currentScore = 0;
let $09e991522ca7e64e$var$bestScore = $09e991522ca7e64e$var$getBestScore();
$09e991522ca7e64e$var$bestField.textContent = $09e991522ca7e64e$var$bestScore;
$09e991522ca7e64e$var$button.addEventListener("click", $09e991522ca7e64e$var$loadGame);
function $09e991522ca7e64e$var$loadGame() {
    while($09e991522ca7e64e$var$gameBoard.firstChild)$09e991522ca7e64e$var$gameBoard.removeChild($09e991522ca7e64e$var$gameBoard.firstChild);
    $09e991522ca7e64e$var$grid = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)($09e991522ca7e64e$var$gameBoard);
    $09e991522ca7e64e$var$grid.randomEmptyCell().tile = new (0, $296a42d4036cf796$export$2e2bcd8739ae039)($09e991522ca7e64e$var$gameBoard);
    $09e991522ca7e64e$var$grid.randomEmptyCell().tile = new (0, $296a42d4036cf796$export$2e2bcd8739ae039)($09e991522ca7e64e$var$gameBoard);
    $09e991522ca7e64e$var$score = 0;
    $09e991522ca7e64e$var$scoreField.textContent = $09e991522ca7e64e$var$score;
    $09e991522ca7e64e$var$button.classList.replace("start", "restart");
    $09e991522ca7e64e$var$button.textContent = "Restart";
    $09e991522ca7e64e$var$startMessage.classList.add("hidden");
    $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
    $09e991522ca7e64e$var$winMessage.classList.add("hidden");
    $09e991522ca7e64e$var$endMessage.classList.add("hidden");
    $09e991522ca7e64e$var$button.blur();
    $09e991522ca7e64e$var$setupInput();
}
function $09e991522ca7e64e$var$getBestScore() {
    return +localStorage.getItem("bestScore") || 0;
}
function $09e991522ca7e64e$var$setupInput() {
    window.addEventListener("keydown", $09e991522ca7e64e$var$handleInput, {
        once: true
    });
}
async function $09e991522ca7e64e$var$handleInput(e) {
    switch(e.key){
        case "ArrowUp":
            if (!$09e991522ca7e64e$var$canMoveUp()) {
                $09e991522ca7e64e$var$setupInput();
                return;
            }
            await $09e991522ca7e64e$var$moveUp();
            break;
        case "ArrowDown":
            if (!$09e991522ca7e64e$var$canMoveDown()) {
                $09e991522ca7e64e$var$setupInput();
                return;
            }
            await $09e991522ca7e64e$var$moveDown();
            break;
        case "ArrowLeft":
            if (!$09e991522ca7e64e$var$canMoveLeft()) {
                $09e991522ca7e64e$var$setupInput();
                return;
            }
            await $09e991522ca7e64e$var$moveLeft();
            break;
        case "ArrowRight":
            if (!$09e991522ca7e64e$var$canMoveRight()) {
                $09e991522ca7e64e$var$setupInput();
                return;
            }
            await $09e991522ca7e64e$var$moveRight();
            break;
        default:
            $09e991522ca7e64e$var$setupInput();
            return;
    }
    $09e991522ca7e64e$var$grid.cells.forEach((cell)=>cell.mergeTiles());
    const newTile = new (0, $296a42d4036cf796$export$2e2bcd8739ae039)($09e991522ca7e64e$var$gameBoard);
    $09e991522ca7e64e$var$grid.randomEmptyCell().tile = newTile;
    if (!$09e991522ca7e64e$var$canMoveUp() && !$09e991522ca7e64e$var$canMoveDown() && !$09e991522ca7e64e$var$canMoveLeft() && !$09e991522ca7e64e$var$canMoveRight()) {
        if (!$09e991522ca7e64e$var$winMessage.classList.contains("hidden")) {
            $09e991522ca7e64e$var$endMessage.classList.remove("hidden");
            return;
        }
        $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
        return;
    }
    $09e991522ca7e64e$var$setupInput();
}
function $09e991522ca7e64e$var$moveUp() {
    return $09e991522ca7e64e$var$slideTiles($09e991522ca7e64e$var$grid.cellsByColumn);
}
function $09e991522ca7e64e$var$moveDown() {
    return $09e991522ca7e64e$var$slideTiles($09e991522ca7e64e$var$grid.cellsByColumn.map((column)=>[
            ...column
        ].reverse()));
}
function $09e991522ca7e64e$var$moveLeft() {
    return $09e991522ca7e64e$var$slideTiles($09e991522ca7e64e$var$grid.cellsByRow);
}
function $09e991522ca7e64e$var$moveRight() {
    return $09e991522ca7e64e$var$slideTiles($09e991522ca7e64e$var$grid.cellsByRow.map((row)=>[
            ...row
        ].reverse()));
}
function $09e991522ca7e64e$var$slideTiles(cells) {
    return Promise.all(cells.flatMap((group)=>{
        const promises = [];
        for(let i = 1; i < group.length; i++){
            const cell = group[i];
            if (cell.tile == null) continue;
            let lastValidCell;
            for(let j = i - 1; j >= 0; j--){
                const moveToCell = group[j];
                if (!moveToCell.canAccept(cell.tile)) break;
                lastValidCell = moveToCell;
            }
            if (lastValidCell != null) {
                promises.push(cell.tile.waitForTransition());
                if (lastValidCell.tile != null) {
                    lastValidCell.mergeTile = cell.tile;
                    const mergeScore = lastValidCell.tile.value + cell.tile.value;
                    $09e991522ca7e64e$var$currentScore += mergeScore;
                    $09e991522ca7e64e$var$scoreField.textContent = $09e991522ca7e64e$var$currentScore;
                    if ($09e991522ca7e64e$var$currentScore > $09e991522ca7e64e$var$bestScore) {
                        $09e991522ca7e64e$var$bestScore = $09e991522ca7e64e$var$currentScore;
                        localStorage.setItem("bestScore", $09e991522ca7e64e$var$bestScore);
                        $09e991522ca7e64e$var$bestField.textContent = $09e991522ca7e64e$var$bestScore;
                    }
                    // Перевірка на перемогу
                    if (mergeScore === 2048) $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
                } else lastValidCell.tile = cell.tile;
                cell.tile = null;
            }
        }
        return promises;
    }));
}
function $09e991522ca7e64e$var$canMoveUp() {
    return $09e991522ca7e64e$var$canMove($09e991522ca7e64e$var$grid.cellsByColumn);
}
function $09e991522ca7e64e$var$canMoveDown() {
    return $09e991522ca7e64e$var$canMove($09e991522ca7e64e$var$grid.cellsByColumn.map((column)=>[
            ...column
        ].reverse()));
}
function $09e991522ca7e64e$var$canMoveLeft() {
    return $09e991522ca7e64e$var$canMove($09e991522ca7e64e$var$grid.cellsByRow);
}
function $09e991522ca7e64e$var$canMoveRight() {
    return $09e991522ca7e64e$var$canMove($09e991522ca7e64e$var$grid.cellsByRow.map((row)=>[
            ...row
        ].reverse()));
}
function $09e991522ca7e64e$var$canMove(cells) {
    return cells.some((group)=>{
        return group.some((cell, index)=>{
            if (index === 0) return false;
            if (cell.tile == null) return false;
            const moveToCell = group[index - 1];
            return moveToCell.canAccept(cell.tile);
        });
    });
}


//# sourceMappingURL=index.4b8579e7.js.map
